import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ImageMarquee } from "@/components/ImageMarquee";
import { HandStamped } from "@/components/HandStamped";
import { Manifesto } from "@/components/Manifesto";
import { TheDrop } from "@/components/TheDrop";
import { TierSelector } from "@/components/TierSelector";
import { FitBand } from "@/components/FitBand";
import { JoinList } from "@/components/JoinList";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <ImageMarquee />
      <HandStamped />
      <Manifesto />
      <FitBand />
      <TheDrop />
      <JoinList />
      <Footer />
    </div>
  );
}
